import { FC } from "react";
import PageErrorTemplate from "./PageErrorTemplate";

const PageError500: FC = () => {
  return (
    <PageErrorTemplate errorCode={500} errorMessage="It's not you, it's us." />
  );
};

export default PageError500;